import React from 'react';
import { Control, actions } from 'react-redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VehicleDiv from '../../forms/controls/vehicleDiv';
import {
  getFormData,
  getFormMetaController,
} from '../../../selectors/formSelector';
import FormApi from '../../../api/formApi';
import * as logtypes from '../../../common/logtypes';
import {
  ltLogger,
  getQueryParams,
  reportFieldEngagement,
} from '../../../bootstrap';
import DataLoader from '../../common/DataLoader';
/*eslint-disable react/no-multi-comp,react/no-danger*/
import storageFactory from '../../../utils/storageFactory';
import {
  registerDefaultedField,
  clearDefaultedField,
} from '../../../actions/formTrackingActions';
import { bindKeyboardEvents } from '../../../common/keyboardHandlers';
import { reportErrorLogs } from '../../../utils/reportErrorLogs';

const storage = storageFactory();

const SelectedWrapper = (props) => {
  let inputProps = Object.assign({}, props);
  delete inputProps.children;
  delete inputProps.submitted;
  delete inputProps.touched;
  delete inputProps.modelValue;

  const isSelected =
    props.autoFocus &&
    (props.submitted || (props.modelValue === props.htmlFor && props.touched));

  return (
    <label
      htmlFor={props.htmlFor}
      tabIndex="0"
      className={isSelected ? 'selected' : null}
      onKeyDown={bindKeyboardEvents(props.onClick)}
    >
      <input {...inputProps} />
      {props.children}
    </label>
  );
};

SelectedWrapper.propTypes = {
  htmlFor: PropTypes.string,
  autoFocus: PropTypes.bool,
  submitted: PropTypes.bool,
  children: PropTypes.object,
  modelValue: PropTypes.string,
  touched: PropTypes.bool,
};

let makeOrderOverride = [];
let getTopMakeCountAndMakeCollection = (
  makeResponse,
  makeVehicleOrderOverride
) => {
  makeResponse = Array.isArray(makeResponse) ? makeResponse : [];
  let actualTopmakesCount = 0;
  if (makeVehicleOrderOverride.length === 0) {
    return [undefined, makeResponse];
  }
  const makeCollection = makeResponse
    .map((item, index) => {
      const makeFound = makeVehicleOrderOverride.find(
        (makeItem) =>
          makeItem.make.toLowerCase() === item.makeName.toLowerCase()
      );
      const maxTopMakeOrder = makeVehicleOrderOverride.length;
      if (makeFound) {
        actualTopmakesCount++;
        return { ...item, ...{ order: makeFound.order } };
      }
      return { ...item, ...{ order: maxTopMakeOrder + (index + 1) } };
    })
    .sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
  return [actualTopmakesCount, makeCollection];
};

class VehicleMake extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      makes: [],
      topmakesCount: 6,
      purchaseLoanSubType: [
        { label: 'New', value: 'NewCarPurchase' },
        { label: 'Used', value: 'UsedCarPurchase' },
      ],
      isDataLoaded: false,
      clearedDefaultedField: false,
    };
  }

  componentWillMount() {
    const { formData, dispatch, formMeta } = this.props;
    let loanType =
      formData && formData.AutomobileLoanType
        ? formData.AutomobileLoanType
        : undefined;
    let loanSubType =
      formMeta && formMeta.AutomobileLoanSubType
        ? formMeta.AutomobileLoanSubType
        : undefined;
    if (loanSubType !== undefined) {
      dispatch(actions.setTouched('formMeta.AutomobileLoanSubType'));
      dispatch(actions.change('formMeta.AutomobileLoanSubType', loanSubType));
    }
    if (!loanType) {
      loanType =
        getQueryParams('AutomobileLoanType') ||
        getQueryParams('loan-type') ||
        undefined;
    }
    if (loanType && !loanSubType) {
      loanType = loanType.toUpperCase();
      switch (loanType) {
        case 'PURCHASE':
        case 'NEWCARPURCHASE':
          loanSubType = 'NewCarPurchase';
          dispatch(actions.setTouched('formMeta.AutomobileLoanSubType'));
          break;
        case 'USEDCARPURCHASE':
          loanSubType = 'UsedCarPurchase';
          dispatch(actions.setTouched('formMeta.AutomobileLoanSubType'));
          break;
        case 'REFINANCE':
          loanSubType = 'REFINANCE';
          dispatch(actions.setTouched('formMeta.AutomobileLoanSubType'));
          break;
        case 'BUYOUTLEASE':
          loanSubType = 'BUYOUTLEASE';
          dispatch(actions.setTouched('formMeta.AutomobileLoanSubType'));
          break;
      }
      dispatch(actions.change('formMeta.AutomobileLoanSubType', loanSubType));
    }

    this.setState({ loanSubType });
  }

  componentDidMount() {
    // PHX-7000 :: INFO / TECH-DEBT :: Zach James
    // I didn't add default logic for VehicleMake because
    // we ALWAYS fire Field Engagement events, and the
    // default events are mainly to fill the gap where
    // Field Engagement events don't fire
    // The exception to that is the loanSubType, which
    // we don't always fire events for since the user isn't required
    // to click on one of the loan types
    // Note that loanSubType only shows up on Purchase
    const loanSubType = this.state.loanSubType;
    const purchaseSubTypes = this.state.purchaseLoanSubType;
    if (
      loanSubType &&
      (loanSubType === purchaseSubTypes[0].value ||
        loanSubType === purchaseSubTypes[1].value)
    ) {
      this.props.dispatch(
        registerDefaultedField('AutomobileLoanSubType', loanSubType)
      );
    }
    const { step } = this.props;
    let { topmakes } = step;
    let topMakesSequence = topmakes ? topmakes.split(',') : [];
    makeOrderOverride = topMakesSequence
      .reduce(
        (unique, item) =>
          unique.includes(item) ? unique : [...unique, item.trim()],
        []
      )
      .map((make, index) => {
        return { make, order: index + 1 };
      });
    this.fetchVehicleMakes(this.state.loanSubType, makeOrderOverride);
  }

  getVehicleCondition = (selectedLoanType) => {
    switch (selectedLoanType) {
      case 'NewCarPurchase':
        return 'new';
      case 'UsedCarPurchase':
      case 'REFINANCE':
      case 'BUYOUTLEASE':
        return 'used';
      default:
        return null;
    }
  };

  fetchVehicleMakes = (selectedLoanType, makeOrderOverride) => {
    let vehicleCondition = this.getVehicleCondition(selectedLoanType);
    let currentComponent = this;
    currentComponent.setState({ isDataLoaded: false });

    // PHX-7148: Log VehicleMake fetch start
    const baseLogData = {
      selectedLoanType,
      vehicleCondition,
      userAgent: navigator.userAgent,
      isAndroid: /Android/i.test(navigator.userAgent),
      formId: this.props.formMeta?.formId,
      formUuid: this.props.formMeta?.formUuid,
      clickSessionId: this.props.formMeta?.clickSessionId
    };

    reportErrorLogs('VehicleMake fetch started', baseLogData);

    return FormApi.fetchVehicleMakes(
      vehicleCondition,
      storage.getItem('lt_sessionKey')
    )
      .then((data) => {
        if (data && data.response && data.response.error) {
          reportErrorLogs('VehicleMake API returned error', {
            ...baseLogData,
            apiError: data.response.error,
            responseData: data
          });
          ltLogger(logtypes.ERROR, undefined, {}, undefined, {
            error: new Error(data.response.error),
          });
          return null;
        }
        let makeResponse = data ? (data.response ? data.response : data) : [];
        //If no makes is configured in formbuilder then show 6 top makes from top by default.
        const [topmakesCount = 6, orderedMakeCollection] =
          getTopMakeCountAndMakeCollection(makeResponse, makeOrderOverride);

        // PHX-7148: Log VehicleMake fetch success
        reportErrorLogs('VehicleMake fetch completed successfully', {
          ...baseLogData,
          makesCount: orderedMakeCollection?.length
        });

        currentComponent.setState({
          makes: orderedMakeCollection,
          topmakesCount,
          isDataLoaded: true,
        });
      })
      .catch((error) => {
        // PHX-7148: Log VehicleMake fetch failure
        reportErrorLogs('VehicleMake fetch failed', {
          ...baseLogData,
          error: error?.message,
          errorStack: error?.stack
        });
        ltLogger(logtypes.ERROR, undefined, {}, undefined, { error: error });
      });
  };

  render() {
    const { isDataLoaded, purchaseLoanSubType } = this.state;
    const { formMeta } = this.props;
    return !isDataLoaded ? (
      <DataLoader />
    ) : (
      <div>
        <div aria-label="Input for Vehicle Type">
          {(formMeta.AutomobileLoanSubType === 'NewCarPurchase' ||
            formMeta.AutomobileLoanSubType === 'UsedCarPurchase') &&
            purchaseLoanSubType.map((item) => (
              <div
                key={item.value}
                className={`ltFormRadioControl ltFormRadioControl${item.value}`}
              >
                <Control.radio
                  name={item.value}
                  id={item.value}
                  model={`formMeta.AutomobileLoanSubType`}
                  className={`ltFormRadioButton ${item.value}`}
                  component={SelectedWrapper}
                  value={item.value}
                  changeAction={(model, value, event) => (dispatch) => {
                    if (event && value !== event.currentValue) {
                      return;
                    }
                    reportFieldEngagement('AutomobileLoanSubType', value);
                    if (!this.state.clearedDefaultedField) {
                      dispatch(clearDefaultedField('AutomobileLoanSubType'));
                      this.setState({ clearedDefaultedField: true });
                    }
                    dispatch(actions.change(model, value));
                    if (
                      event &&
                      this.props.steps.length === 1 &&
                      event.currentValue === value
                    ) {
                      this.fetchVehicleMakes(value, makeOrderOverride);
                    }
                  }}
                  mapProps={{
                    autoFocus: (props) => props.modelValue === item.value,
                    htmlFor: item.value,
                    submitted: ({ fieldValue }) => fieldValue.submitted,
                    modelValue: (props) => props.modelValue,
                    touched: ({ fieldValue }) => fieldValue.touched,
                    onClick: (props) => () => {
                      if (props.value === props.controlProps.value) {
                        props.dispatch(actions.setTouched(props.model));
                        props.dispatch(
                          props.changeAction(props.model, props.value, {
                            currentValue: props.controlProps.value,
                          })
                        );
                      }
                    },
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.label }} />
                </Control.radio>
              </div>
            ))}
        </div>
        <VehicleDiv
          fetchedVehicleMakes={this.state.makes}
          maxTopMakeOrder={this.state.topmakesCount}
          handleNext={this.props.handleNext}
          parentProps={this.props}
        />
      </div>
    );
  }
}

/*eslint-enable */
VehicleMake.propTypes = {
  step: PropTypes.object,
  steps: PropTypes.array,
  handleNext: PropTypes.func,
  fieldValue: PropTypes.object,
  modelValue: PropTypes.object,
  controlProps: PropTypes.object,
  viewValue: PropTypes.string,
  value: PropTypes.string,
  dispatch: PropTypes.func,
  model: PropTypes.object,
  changeAction: PropTypes.func,
  formData: PropTypes.object,
  formMeta: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    formData: getFormData(state),
    formMeta: getFormMetaController(state),
  };
}

export default connect(mapStateToProps)(VehicleMake);
